import { OpenAccountState } from "@/feature/OpenAccount/store/interface";
import { OpenAccountFormStep } from "@/feature/OpenAccount/mixins/interface";

export default <OpenAccountState> {
	legalEntityLoading: false,
	legalEntity: null,
	invoice: null,
	invoiceList: [],
	step: OpenAccountFormStep.PHONE_NUMBER,
	requestData: null,
	phoneNumber: '',
	legalEntityLoadingHint: ''
}